import PhotoDotsIndicator from '../src/PhotoDotsIndicator/PhotoDotsIndicator';
export default PhotoDotsIndicator;
